/**
 * Generated bundle index. Do not edit.
 */
export { TreeSelectDefaultOptions, TreeSelectComponent, ItemPipe, NgxTreeSelectModule, ExpandMode } from './index';
export { TreeSelectItemComponent as ɵc } from './components/tree-select-item.component';
export { CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR as ɵa } from './components/tree-select.component';
export { OffClickDirective as ɵd } from './directives/off-click.directive';
export { SelectService as ɵb } from './services/select.service';
//# sourceMappingURL=ngx-tree-select.ng-flat.js.map


//////////////////
// WEBPACK FOOTER
// ./.tmp/ngx-tree-select/src/ngx-tree-select.ng-flat.js
// module id = 169
// module chunks = 0